import { HorizontalSafeAreaContainer } from '../../../../../../components';
import { GiftCardCheckoutScreen } from '../../../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <HorizontalSafeAreaContainer>
      <GiftCardCheckoutScreen />
    </HorizontalSafeAreaContainer>
  );
}
